import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ILog } from '@models';
import { ODataQueryOptions } from '@services/generics/odata.query';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

import { map } from 'rxjs/operators';

import { AppStateFacade } from '@app-state';

interface ODataNumber {
    '@odata.context': string;
    'value': number;
}

@Injectable()
export class LogService extends ODataService<ILog, number> {
    public reportsUrl: string;
    protected _endpoint: string;
    private _realGridCountUrl: string;

    constructor(
        http: HttpClient,
        { authConfig }: AppStateFacade,
    ) {
        super(http, MapperService.logMap);
        this._endpoint = `${authConfig.odataBaseUrl}/RobotLogs`;
        this.reportsUrl = `${this._endpoint}/UiPath.Server.Configuration.OData.Reports`;
        this._realGridCountUrl = `${this._endpoint}/UiPath.Server.Configuration.OData.GetTotalCount`;
    }

    public getRealCount(queryOptions: ODataQueryOptions) {
        return this._http.get<ODataNumber>(`${this._realGridCountUrl}${this.getQueryString(queryOptions)}`)
            .pipe(
                map(response => response.value),
            );
    }
}
